// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_hk","advertCardHeader__actions":"c-a_hl","advertCardHeader__bottomLabel":"c-a_hm"};